module.exports = SharedDependencies.React['@local/application'];